<ion-checkbox
  #checkbox
  color="primary"
  slot="start"
  [disabled]="control.disabled"
  [formControl]="control"
  (ionChange)="onCheckedChange()"
  labelPlacement="end">
  @if (label) {
    <div class="ion-text-wrap">{{ label }}</div>
  }
  @if (subtitle) {
    <div class="ion-text-wrap subtitle">{{ subtitle }}</div>
  }
  <div class="ion-text-wrap">
    <ng-content></ng-content>
  </div>
</ion-checkbox>

@if (showError && control?.errors && control?.touched) {
  <div class="error-wrapper">
    <c-validation-error [validationMessages]="control.errors" [controlValue]="control.value"> </c-validation-error>
  </div>
}
